/**
 * Sponsor-type expired labels — centralized so the "Insurance Expired" vs
 * "Corporate Expired" copy lives in one place instead of being hardcoded at
 * each `SelectedSponsorDetail` call site (Samer review, PR #526).
 *
 * Strings are copied VERBATIM from Flutter and must not be paraphrased:
 *   - insuranceExpired → `insurance_child_widget.dart:478`
 *   - corporateExpired → `corporate_child_widget.dart:463`
 * `expiredFallback` is the neutral default when no sponsor type is known.
 */
export const SPONSOR_LABELS = {
  insuranceExpired: 'Insurance Expired',
  corporateExpired: 'Corporate Expired',
  expiredFallback: 'Expired',
} as const;
